import api from './api.js';

import { Modal } from './scripts/modal/modal';
import { ModalsGroup } from './scripts/modal/modals-group';
import { FocusTrap } from './scripts/modal/focus-trap';

api.Modal = Modal;
api.ModalsGroup = ModalsGroup;
api.FocusTrap = FocusTrap;

export default api;
